/**
 * Lý do của các thao tác sửa trực tiếp và xoá Hộ / Vườn / MM (Q6). Máy chủ là nơi chặn thật: trả 422 khi
 * thiếu lý do. Ở đây hỏi trước để người sửa không mất công điền lại, và để lời báo nói bằng tiếng Việt
 * có dấu.
 */
import { esc } from './util.js';
import { openFormDialog } from './form-dialog.js';

const reasonField = ({ label, placeholder, hint }) => `
  <div class="form-row form-row-full">
    <label>${esc(label)} *</label>
    <input name="reason" required maxlength="500" placeholder="${esc(placeholder)}">
    <p class="hint-text">${esc(hint)}</p>
  </div>`;

export const EDIT_REASON_FIELD_HTML = reasonField({
  label: 'Lý do sửa',
  placeholder: 'Vd: Chủ hộ đổi số điện thoại, đã gọi xác nhận',
  hint: 'Ghi vào nhật ký thay đổi cùng tên bạn. Sửa trực tiếp không qua duyệt nên lý do là căn cứ để đối soát về sau.',
});

/** @returns {string|null} lời báo nếu còn thiếu; `null` là đủ. */
export function editReasonError(form) {
  return form.reason.value.trim() ? null : 'Nhập lý do sửa trước khi lưu.';
}

/**
 * Hộp xác nhận xoá kèm lý do. Lỗi của máy chủ (vd còn phiếu nháp tham chiếu) hiện ngay trong hộp, để
 * người xoá không phải gõ lại lý do.
 *
 * @param {object} args
 * @param {string} args.title
 * @param {string} args.message - xoá xong điều gì xảy ra; "Bạn có chắc không?" không giúp ai quyết định
 * @param {(reason: string) => Promise<unknown>} args.remove
 * @param {() => void} args.onDone
 */
export function openDeleteDialog({ title, message, remove, onDone }) {
  openFormDialog({
    title,
    submitLabel: 'Xoá',
    submitIcon: 'delete',
    bodyHtml: `
      <p>${esc(message)}</p>
      ${reasonField({
        label: 'Lý do xoá',
        placeholder: 'Vd: Nhập trùng với hồ sơ khác',
        hint: 'Ghi vào nhật ký thay đổi cùng tên bạn.',
      })}`,
    onSubmit: async (form) => {
      const reason = form.reason.value.trim();
      if (!reason) return 'Nhập lý do xoá.';
      try {
        await remove(reason);
      } catch (err) {
        return err.message;
      }
      onDone();
    },
  });
}
